// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Theme Variables */
:root {
  /* Primary Colors */
  --primary-color: #4D64C1;
  --primary-dark: #3a4f9e;
  --primary-light: #6b82d3;
  --primary-bg: #e8ecf8;
  
  /* Secondary Colors */
  --secondary-color: #4CAF50;
  --secondary-dark: #388E3C;
  --secondary-light: #66BB6A;
  
  /* Neutral Colors */
  --gray-50: #FAFAFA;
  --gray-100: #F5F5F5;
  --gray-200: #EEEEEE;
  --gray-300: #E0E0E0;
  --gray-400: #BDBDBD;
  --gray-500: #9E9E9E;
  --gray-600: #757575;
  --gray-700: #616161;
  --gray-800: #424242;
  --gray-900: #212121;
  
  /* Text Colors */
  --text-primary: #212121;
  --text-secondary: #757575;
  --text-light: #9E9E9E;
  --text-on-primary: #FFFFFF;
  
  /* Status Colors */
  --success-color: #4CAF50;
  --warning-color: #FF9800;
  --error-color: #F44336;
  --info-color: #2196F3;
  
  /* Component Specific */
  --navbar-bg: #4D64C1;
  --navbar-text: #FFFFFF;
  --card-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  --card-hover-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  
  /* Spacing */
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-xxl: 3rem;
  
  /* Border Radius */
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-full: 50%;
  
  /* Transitions */
  --transition-fast: 150ms ease;
  --transition-base: 300ms ease;
  --transition-slow: 500ms ease;
}

/* Global Styles */
body {
  color: var(--text-primary);
  background-color: var(--gray-50);
}

/* Buttons */
.btn-primary {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: var(--text-on-primary) !important;
  transition: all var(--transition-fast);
}

.btn-primary:hover,
.btn-primary:focus {
  background-color: var(--primary-dark) !important;
  border-color: var(--primary-dark) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.btn-secondary {
  background-color: var(--secondary-color) !important;
  border-color: var(--secondary-color) !important;
  color: var(--text-on-primary) !important;
}

.btn-secondary:hover,
.btn-secondary:focus {
  background-color: var(--secondary-dark) !important;
  border-color: var(--secondary-dark) !important;
}

/* Cards */
.card {
  border: 1px solid var(--gray-300);
  border-radius: var(--radius-md);
  box-shadow: var(--card-shadow);
  transition: all var(--transition-base);
}

.card:hover {
  box-shadow: var(--card-hover-shadow);
  transform: translateY(-2px);
}

/* Navbar */
.navbar {
  background-color: var(--navbar-bg) !important;
}

.navbar-brand,
.navbar-nav .nav-link {
  color: var(--navbar-text) !important;
}

.navbar-nav .nav-link:hover {
  opacity: 0.85;
}

/* Forms */
.form-control,
.form-select {
  border-color: var(--gray-300);
  border-radius: var(--radius-sm);
  transition: border-color var(--transition-fast);
}

.form-control:focus,
.form-select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}

/* Badges */
.badge-primary {
  background-color: var(--primary-color) !important;
}

.badge-success {
  background-color: var(--success-color) !important;
}

.badge-warning {
  background-color: var(--warning-color) !important;
}

.badge-danger {
  background-color: var(--error-color) !important;
}

/* Text Colors */
.text-primary {
  color: var(--primary-color) !important;
}

.text-secondary {
  color: var(--text-secondary) !important;
}

.text-success {
  color: var(--success-color) !important;
}

.text-danger {
  color: var(--error-color) !important;
}

.text-muted {
  color: var(--text-light) !important;
}

/* Links */
a {
  color: var(--primary-color);
  text-decoration: none;
  transition: color var(--transition-fast);
}

a:hover {
  color: var(--primary-dark);
}

/* Tables */
.table {
  border-color: var(--gray-300);
}

.table thead th {
  background-color: var(--gray-100);
  border-color: var(--gray-300);
  color: var(--text-primary);
}

/* Alerts */
.alert-success {
  background-color: #E8F5E9;
  border-color: var(--success-color);
  color: #1B5E20;
}

.alert-danger {
  background-color: #FFEBEE;
  border-color: var(--error-color);
  color: #B71C1C;
}

.alert-warning {
  background-color: #FFF3E0;
  border-color: var(--warning-color);
  color: #E65100;
}

.alert-info {
  background-color: var(--primary-bg);
  border-color: var(--info-color);
  color: #0D47A1;
}

/* Hero Sections */
.hero-section {
  background: linear-gradient(135deg, var(--primary-dark) 0%, var(--primary-color) 100%);
  color: var(--text-on-primary);
  padding: 4rem 0;
}

/* Product Cards */
.product-card {
  background: white;
  border: 1px solid var(--gray-300);
  border-radius: var(--radius-md);
  transition: all var(--transition-base);
}

.product-card:hover {
  box-shadow: var(--card-hover-shadow);
  transform: translateY(-2px);
  border-color: var(--primary-light);
}

/* Price Display */
.price {
  color: var(--secondary-color);
  font-weight: 600;
}

/* Loading States */
.spinner-border {
  color: var(--primary-color);
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--gray-100);
}

::-webkit-scrollbar-thumb {
  background: var(--gray-400);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--gray-500);
}`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;;EAErB,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;;EAE1B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;;EAE1B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;;EAErB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,2CAA2C;EAC3C,mDAAmD;;EAEnD,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;;EAEnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;;EAElB,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,YAAY;AACZ;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;;EAEE,gDAAgD;EAChD,4CAA4C;EAC5C,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;;EAEE,kDAAkD;EAClD,8CAA8C;AAChD;;AAEA,UAAU;AACV;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,6CAA6C;AAC/C;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA,UAAU;AACV;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA;;EAEE,kCAAkC;EAClC,iDAAiD;AACnD;;AAEA,WAAW;AACX;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,sFAAsF;EACtF,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,iCAAiC;EACjC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Global Theme Variables */\n:root {\n  /* Primary Colors */\n  --primary-color: #4D64C1;\n  --primary-dark: #3a4f9e;\n  --primary-light: #6b82d3;\n  --primary-bg: #e8ecf8;\n  \n  /* Secondary Colors */\n  --secondary-color: #4CAF50;\n  --secondary-dark: #388E3C;\n  --secondary-light: #66BB6A;\n  \n  /* Neutral Colors */\n  --gray-50: #FAFAFA;\n  --gray-100: #F5F5F5;\n  --gray-200: #EEEEEE;\n  --gray-300: #E0E0E0;\n  --gray-400: #BDBDBD;\n  --gray-500: #9E9E9E;\n  --gray-600: #757575;\n  --gray-700: #616161;\n  --gray-800: #424242;\n  --gray-900: #212121;\n  \n  /* Text Colors */\n  --text-primary: #212121;\n  --text-secondary: #757575;\n  --text-light: #9E9E9E;\n  --text-on-primary: #FFFFFF;\n  \n  /* Status Colors */\n  --success-color: #4CAF50;\n  --warning-color: #FF9800;\n  --error-color: #F44336;\n  --info-color: #2196F3;\n  \n  /* Component Specific */\n  --navbar-bg: #4D64C1;\n  --navbar-text: #FFFFFF;\n  --card-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  --card-hover-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  \n  /* Spacing */\n  --spacing-xs: 0.25rem;\n  --spacing-sm: 0.5rem;\n  --spacing-md: 1rem;\n  --spacing-lg: 1.5rem;\n  --spacing-xl: 2rem;\n  --spacing-xxl: 3rem;\n  \n  /* Border Radius */\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n  --radius-full: 50%;\n  \n  /* Transitions */\n  --transition-fast: 150ms ease;\n  --transition-base: 300ms ease;\n  --transition-slow: 500ms ease;\n}\n\n/* Global Styles */\nbody {\n  color: var(--text-primary);\n  background-color: var(--gray-50);\n}\n\n/* Buttons */\n.btn-primary {\n  background-color: var(--primary-color) !important;\n  border-color: var(--primary-color) !important;\n  color: var(--text-on-primary) !important;\n  transition: all var(--transition-fast);\n}\n\n.btn-primary:hover,\n.btn-primary:focus {\n  background-color: var(--primary-dark) !important;\n  border-color: var(--primary-dark) !important;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.btn-secondary {\n  background-color: var(--secondary-color) !important;\n  border-color: var(--secondary-color) !important;\n  color: var(--text-on-primary) !important;\n}\n\n.btn-secondary:hover,\n.btn-secondary:focus {\n  background-color: var(--secondary-dark) !important;\n  border-color: var(--secondary-dark) !important;\n}\n\n/* Cards */\n.card {\n  border: 1px solid var(--gray-300);\n  border-radius: var(--radius-md);\n  box-shadow: var(--card-shadow);\n  transition: all var(--transition-base);\n}\n\n.card:hover {\n  box-shadow: var(--card-hover-shadow);\n  transform: translateY(-2px);\n}\n\n/* Navbar */\n.navbar {\n  background-color: var(--navbar-bg) !important;\n}\n\n.navbar-brand,\n.navbar-nav .nav-link {\n  color: var(--navbar-text) !important;\n}\n\n.navbar-nav .nav-link:hover {\n  opacity: 0.85;\n}\n\n/* Forms */\n.form-control,\n.form-select {\n  border-color: var(--gray-300);\n  border-radius: var(--radius-sm);\n  transition: border-color var(--transition-fast);\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);\n}\n\n/* Badges */\n.badge-primary {\n  background-color: var(--primary-color) !important;\n}\n\n.badge-success {\n  background-color: var(--success-color) !important;\n}\n\n.badge-warning {\n  background-color: var(--warning-color) !important;\n}\n\n.badge-danger {\n  background-color: var(--error-color) !important;\n}\n\n/* Text Colors */\n.text-primary {\n  color: var(--primary-color) !important;\n}\n\n.text-secondary {\n  color: var(--text-secondary) !important;\n}\n\n.text-success {\n  color: var(--success-color) !important;\n}\n\n.text-danger {\n  color: var(--error-color) !important;\n}\n\n.text-muted {\n  color: var(--text-light) !important;\n}\n\n/* Links */\na {\n  color: var(--primary-color);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\na:hover {\n  color: var(--primary-dark);\n}\n\n/* Tables */\n.table {\n  border-color: var(--gray-300);\n}\n\n.table thead th {\n  background-color: var(--gray-100);\n  border-color: var(--gray-300);\n  color: var(--text-primary);\n}\n\n/* Alerts */\n.alert-success {\n  background-color: #E8F5E9;\n  border-color: var(--success-color);\n  color: #1B5E20;\n}\n\n.alert-danger {\n  background-color: #FFEBEE;\n  border-color: var(--error-color);\n  color: #B71C1C;\n}\n\n.alert-warning {\n  background-color: #FFF3E0;\n  border-color: var(--warning-color);\n  color: #E65100;\n}\n\n.alert-info {\n  background-color: var(--primary-bg);\n  border-color: var(--info-color);\n  color: #0D47A1;\n}\n\n/* Hero Sections */\n.hero-section {\n  background: linear-gradient(135deg, var(--primary-dark) 0%, var(--primary-color) 100%);\n  color: var(--text-on-primary);\n  padding: 4rem 0;\n}\n\n/* Product Cards */\n.product-card {\n  background: white;\n  border: 1px solid var(--gray-300);\n  border-radius: var(--radius-md);\n  transition: all var(--transition-base);\n}\n\n.product-card:hover {\n  box-shadow: var(--card-hover-shadow);\n  transform: translateY(-2px);\n  border-color: var(--primary-light);\n}\n\n/* Price Display */\n.price {\n  color: var(--secondary-color);\n  font-weight: 600;\n}\n\n/* Loading States */\n.spinner-border {\n  color: var(--primary-color);\n}\n\n/* Custom Scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--gray-100);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--gray-400);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--gray-500);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
